import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { AuthenticatedFetchSubprovider } from 'bitski-provider'; // A subprovider that loads accounts from a custom rpc endpoint.
// This is necessary because to guarantee that account related calls go through Bitski

export var RemoteAccountSubprovider = /*#__PURE__*/function (_AuthenticatedFetchSu) {
  _inherits(RemoteAccountSubprovider, _AuthenticatedFetchSu);

  var _super = _createSuper(RemoteAccountSubprovider);

  function RemoteAccountSubprovider() {
    _classCallCheck(this, RemoteAccountSubprovider);

    return _super.apply(this, arguments);
  }

  _createClass(RemoteAccountSubprovider, [{
    key: "handleRequest",
    value: function handleRequest(payload, next, end) {
      if (payload.method === 'eth_accounts') {
        this.handleAuthenticatedRequest(payload, next, end);
      } else {
        next();
      }
    }
  }]);

  return RemoteAccountSubprovider;
}(AuthenticatedFetchSubprovider);